import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowAssignmentResourceV3 = OpalApiComponent<
  'V3',
  'workflow_assignment'
>

export const workflowAssignmentResourceFactory: Factory<WorkflowAssignmentResourceV3> =
  Factory.define<WorkflowAssignmentResourceV3>(({ sequence }) => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'workflow_assignment',
      attributes: {
        assignment_type: 'task',
        created_at: now,
        updated_at: now,
        metadata: null,
        position: sequence,
      },
      relationships: {
        created_by_user: { data: { id: uuidV4(), type: 'user' } },
        assigned_user: { data: null },
        stage: { data: { id: uuidV4(), type: 'workflow_stage' } },
        responses: { data: [] },
      },
    } satisfies WorkflowAssignmentResourceV3
  })
